var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCard',[_c('Device',{ref:"deviceView",attrs:{"prefix":"btfs_"},on:{"change":_vm.onChangedSite}})],1),_c('Event',{ref:"eventView",attrs:{"prefix":"btfs_"},on:{"click":_vm.onClickEvent}}),_c('EventDialog',{ref:"eventDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }